import React from "react";
import Checkbox from "../misc/elements/Checkbox";

const BoxTypeHolder = ({ boxType, playerBoxtypes, onClick, onDelete }) => {
  return (
    <div
      className="divRow"
      style={{
        height: "40px",
        width: "100%",
        minWidth: "800px",
        border: "3px solid grey",
        justifyContent: "center",
        backgroundColor: boxType.colors.primary,
      }}
    >
      {onDelete && (
        <img
          onClick={() => onDelete(boxType)}
          src="/icons/icon_delete.png"
          style={{ height: "90%", padding: "5px", cursor: "pointer" }}
        />
      )}
      {!onDelete && (
        <div className="divRow" style={{ marginLeft: "5px" }}>
          <img src="/icons/icon_player.png" className="icon25" />
          <div
            className="textBold"
            style={{ color: boxType.colors.text, marginLeft: "5px" }}
          >
            {boxType.used}
          </div>
        </div>
      )}
      <div
        onClick={() => onClick(boxType)}
        className="textBold"
        style={{
          cursor: "pointer",
          color: boxType.colors.text,
          fontSize: "24px",
          flex: 1,
          textAlign: "center",
        }}
      >
        {boxType.names.plural}
      </div>
      <div style={{ marginRight: "15px" }}>
        <Checkbox
          item={boxType.names.plural}
          includeList={playerBoxtypes?.map((kv) => kv.value.names.plural)}
          size="30"
        />
      </div>
    </div>
  );
};

export default BoxTypeHolder;
